import { render } from "./footerStrony.vue?vue&type=template&id=4332df20&scoped=true"
import script from "./footerStrony.vue?vue&type=script&lang=js"
export * from "./footerStrony.vue?vue&type=script&lang=js"

import "./footerStrony.vue?vue&type=style&index=0&id=4332df20&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4332df20"]])

export default __exports__